module.exports = __webpack_public_path__ + "img/codorniu_16.7b08cd09.jpg";